import PelvicLymphNodeMetastases from "./PelvicLymphNodeMetastases";

export default PelvicLymphNodeMetastases;
